import styled from 'styled-components';

export const NotificationItemContainer = styled.div`
  margin-bottom: 8px;
  width: 100%;
`;
